import { setScreenShare } from '@shoflo/studio-redux/actions/screenShare/setScreenShare';
import removePresenter from 'actions/source/removePresenter';

async function agoraScreenShareStopped({ getState, dispatch }, { attendeeId }) {
  const { broadcastSources } = getState();

  const source = broadcastSources?.sources?.find(s => s.value === attendeeId);

  if (source) {
    dispatch(removePresenter(attendeeId));
  }

  dispatch(setScreenShare(true));
}

export default agoraScreenShareStopped;
